import { UniqMap } from 'src/lib/UniqMap';
import { PROJECT_CATEGORY, PROJECT_TYPE } from './const';

const PROJECT_TYPE_PROPS = new UniqMap();

// canvas category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.canvas, {
  category: PROJECT_CATEGORY.canvas,
  label: 'Document',
  description: 'Improve you project copies with basic copywriting.',
  title: 'Document',
});

// "ad" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.facebookAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'Facebook Ad',
  description: 'Generate exceptionally effective copy for your Facebook Ads.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.googleAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'Google Search Ad',
  description: 'Create high-converting descriptions and headlines for your Google Search Ads.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.outbrainAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'Outbrain Headline',
  description: 'Generate irresistible Outbrain headlines that drive traffic.',
  supportsCustomerPersona: false,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.taboolaAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'Taboola Headline',
  description: 'Generate irresistible Taboola headlines that drive traffic.',
  supportsCustomerPersona: false,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.twitterAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'X Ad',
  description: 'Write scroll-stopping copy for your X Ads.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.linkedinAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'LinkedIn Text Ad',
  description: 'Generate LinkedIn Text Ads that stand out and convert.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.pinterestAd, {
  category: PROJECT_CATEGORY.ads,
  label: 'Pinterest Ad',
  description: 'Step up your Pinterest game with stellar descriptions and titles.',
  supportsCustomerPersona: true,
});

// Teads
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.teadsSingleImage, {
  category: PROJECT_CATEGORY.ads,
  label: 'Teads Single Image',
  description: 'Generate effective descriptions and headlines for Single Image ads.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.teadsSingleVideo, {
  category: PROJECT_CATEGORY.ads,
  label: 'Teads Single Video',
  description: 'Generate effective descriptions and headlines for Single Video ads.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.teadsCarousel, {
  category: PROJECT_CATEGORY.ads,
  label: 'Teads Carousel',
  description: 'Generate effective headlines for Carousel ads.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.teadsSocialLayout1, {
  category: PROJECT_CATEGORY.ads,
  label: 'Teads Social Layout I',
  description:
    'Generate effective primary texts, headlines and descriptions for Social Layout I ads.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.teadsSocialLayout2, {
  category: PROJECT_CATEGORY.ads,
  label: 'Teads Social Layout II',
  description: 'Generate effective primary texts for Social Layout II ads.',
});

PROJECT_TYPE_PROPS.add(PROJECT_TYPE.continuousOptimization, {
  category: PROJECT_CATEGORY.websitePersonalization,
  label: 'Website Automation',
  description:
    'Get up to 30% more conversions by installing Anyword on your site.\nYour visitors will be shown different copy variations and Anyword will learn what works and improve over time.',
  title: 'Project',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.wtmHomePage, {
  category: PROJECT_CATEGORY.websitePersonalization,
  label: 'Website Automation',
  description:
    'Get up to 30% more conversions by installing Anyword on your site.\nYour visitors will be shown different copy variations and Anyword will learn what works and improve over time.',
  title: 'Project',
});

// "landingPage" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.landingPageBuilder, {
  category: PROJECT_CATEGORY.landingPage,
  label: 'New Landing Page Copy',
  description:
    'Transform a product description into an entire landing page with this powerful tool.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.seoMetaDescription, {
  category: PROJECT_CATEGORY.landingPage,
  label: 'SEO Meta Description',
  description: 'Generate click-worthy meta descriptions to increase your visibility on Google.',
});

// "productDescription" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.productDescription, {
  category: PROJECT_CATEGORY.productDescription,
  label: 'Product Description',
  description: 'Write persuasive product descriptions that sell.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.featuresToBenefits, {
  category: PROJECT_CATEGORY.productDescription,
  label: 'Features to Benefits',
  description: 'Turn your feature-rich offerings into benefits that inspire action.',
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.amazonProductDescription, {
  category: PROJECT_CATEGORY.productListing,
  label: 'Amazon Product Listing',
  description: 'Write persuasive product descriptions that sell.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.walmartProductListing, {
  category: PROJECT_CATEGORY.productListing,
  label: 'Walmart Product Listing',
  description: 'Write persuasive product listings for Walmart.',
  supportsCustomerPersona: true,
});

// "social" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.facebookSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'Facebook Post',
  description: 'Create engaging copy for your Facebook posts to maximize organic reach.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.instagramSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'Instagram Caption',
  description: 'Generate catchy captions for your Instagram posts.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.twitterSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'X Post',
  description: 'Generate witty tweets to keep your followers engaged.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.linkedinSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'LinkedIn Post',
  description: 'Cut through the noise by generating compelling copy for your LinkedIn posts.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.pinterestSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'Pinterest Pin',
  description: 'Step up your Pinterest game with stellar descriptions and titles.',
  supportsCustomerPersona: true,
});
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.youtubeSocial, {
  category: PROJECT_CATEGORY.social,
  label: 'YouTube Description',
  description: 'Write smart YouTube titles and descriptions to help viewers find your videos.',
  supportsCustomerPersona: true,
});

// "blog" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.blogPostBuilder, {
  category: PROJECT_CATEGORY.blog,
  label: 'Blog Post',
  description: 'Go from a blank page to a brilliant blog post in minutes.',
  title: 'Blog',
});

// "email" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.emailSubjectLine, {
  category: PROJECT_CATEGORY.email,
  label: 'Email Subject Line',
  description: 'Write enticing subject lines for all types of emails.',
  supportsCustomerPersona: true,
});

PROJECT_TYPE_PROPS.add(PROJECT_TYPE.emailPromotional, {
  category: PROJECT_CATEGORY.email,
  label: 'Promotional Email',
  description:
    'Have something amazing for your customers? Let them know!\n' +
    'Write an awesome email about a new product or an exciting promotion.',
  supportsCustomerPersona: true,
});

PROJECT_TYPE_PROPS.add(PROJECT_TYPE.emailColdOutreach, {
  category: PROJECT_CATEGORY.email,
  label: 'Cold Email',
  description:
    'Create powerful, convincing emails to attract potential customers to your product or service.',
  supportsCustomerPersona: true,
});

// "sms" category
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.sms, {
  category: PROJECT_CATEGORY.sms,
  label: 'Promotional SMS',
  description: 'Generate text messages that actually sell.',
  supportsCustomerPersona: true,
});

// Shopify app-specific projects
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.shopifyProduct, {
  category: PROJECT_CATEGORY.productListing,
  label: 'Improve Your Existing Shopify Product Page',
  description: `Get up to 30% more conversions by installing Anyword on your store.
     Your visitors will be shown different copy variations for product name and product description
      and Anyword will learn what works and improve over time.`,
});

PROJECT_TYPE_PROPS.add(PROJECT_TYPE.shopifyProductsDescription, {
  category: PROJECT_CATEGORY.productListing,
  label: 'Shopify Product Descriptions',
  description: 'Create compelling product descriptions to boost conversions on your Shopify store.',
});

PROJECT_TYPE_PROPS.add(PROJECT_TYPE.shopifyLandingPage, {
  label: 'Shopify Landing Page',
});

// deprecated
PROJECT_TYPE_PROPS.add(PROJECT_TYPE.blogPost, {
  label: 'Blog Post (legacy)',
});

const getProjectTypeProp = (type, propName, defaultValue = null) => {
  const props = PROJECT_TYPE_PROPS.get(type);
  return (props && props[propName]) || defaultValue;
};

export const getProjectTypeCategory = (projectType) => getProjectTypeProp(projectType, 'category');

export const getProjectTypeLabel = (projectType) =>
  getProjectTypeProp(projectType, 'label', projectType);

export const getProjectTypeDescription = (projectType) =>
  getProjectTypeProp(projectType, 'description', '');

export const isProjectTypeSupportCustomerPersona = (projectType) =>
  getProjectTypeProp(projectType, 'supportsCustomerPersona', false);

export const getProjectTypeTitle = (projectType) =>
  getProjectTypeProp(projectType, 'title', 'Document');

export const isProjectTypeSupportAudienceTargeting = (projectType) =>
  [PROJECT_TYPE.wtmHomePage, PROJECT_TYPE.continuousOptimization].includes(projectType);

export const isProjectTypeInCategory = (projectType, projectCategory) => {
  const typeCategory = getProjectTypeCategory(projectType);
  return typeCategory === projectCategory;
};

export const isProjectTypeInAdsCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.ads);

export const isProjectTypeInLandingCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.landingPage);

export const isProjectTypeInProductDescriptionCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.productDescription);

export const isProjectTypeInProductListingCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.productListing);

export const isProjectTypeInSocialCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.social);

export const isProjectTypeInBlogCategory = (projectType) =>
  isProjectTypeInCategory(projectType, PROJECT_CATEGORY.blog);

export const getProjectsTypesInCategory = (category) =>
  PROJECT_TYPE_PROPS.getAll()
    .map(([id, projectType]) => ({ id, category: projectType.category }))
    .filter((projectType) => projectType.category === category)
    .map(({ id }) => id);

export const getProjectTypeBriefTitle = (projectType) => {
  const typeLabel = getProjectTypeLabel(projectType);
  if ([PROJECT_TYPE.continuousOptimization, PROJECT_TYPE.wtmHomePage].includes(projectType)) {
    return typeLabel;
  }
  return `${typeLabel} project`;
};
